import { Grid2, IconButton, Typography } from '@mui/material'
import Container from '../../../components/Container'
import { memo, ReactNode, useEffect, useMemo, useState } from 'react'
import api from '../../../utils/axios'
import { IBranch } from 'sierra'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import { Add } from '@mui/icons-material'
import BranchCard from '../../../components/Cards/BranchCard'
import BranchCardSkeleton from '../../../components/Skeletons/BranchCardSkeleton'
import { routes } from '../../../router'
import AssignManagers from './AssignManagers'
import socket from '../../../utils/socket'
import { useAuth } from '../../../hooks/useAuth'
import AssignEmployees from './AssignEmployees'
import { useApp } from '../../../contexts/AppContext'


const SystemBranches = memo(() => {

  const { user } = useAuth()
  const location = useLocation()
  const navigate = useNavigate()
  const { translate } = useApp()

  const [branches, setBranches] = useState<IBranch[] | null>(null)
  const [openAssignManagers, setOpenAssignManagers] = useState<boolean>(false)
  const [openAssignEmployees, setOpenAssignEmployees] = useState<boolean>(false)

  // const outletChild: ReactNode = useMemo(() =>
  //   routes.find(r => r.path?.split('/')[1] == location.pathname.split('/')[1])?.children?.find(r => r.path?.split('/')[0] == location.pathname.split('/')[2])?.children?.find(r => r.path?.split('/')[0] == location.pathname.split('/')[3])?.children?.find(r => r.path?.split('/')[0] == location.pathname.split('/')[4])?.element
  //   , [location])

  const fetchBranches = () => {
    api.get('/branches').then(res => {
      setBranches(res.data)
    }).catch(console.error)
  }

  useEffect(() => {
    fetchBranches()
    socket.on("branches_changed", fetchBranches);
    socket.on("translations_changed", fetchBranches);
    return () => {
      socket.off("branches_changed", fetchBranches);
      socket.off("translations_changed", fetchBranches);
    }
  }, [])


  return (
    <Grid2 container size={'grow'} spacing={location.pathname.split('/')[3] ? 2 : 0} sx={{ transition: { xs: 'none', lg: location.pathname.split('/')[3] ? 'all 0.8s cubic-bezier(0, 0.5, 0.2, 1)' : 'all 0.5s cubic-bezier(0.6, 0, 0.8, 0.4)' } }}>

      <Grid2 container display={{ xs: location.pathname.split('/')[3] ? 'none' : 'flex', lg: 'flex' }} size={{ xs: location.pathname.split('/')[3] ? 0 : 'grow', lg: 'grow' }} flexDirection={'column'} spacing={2}>

        <Container container size={'auto'} padding={2} justifyContent={'space-between'}>
          <Grid2>
            <Typography variant='h4' fontWeight={'bold'} color='primary'>
              {translate("Branches")}
            </Typography>
          </Grid2>
          <Grid2>
            <IconButton onClick={() => {
              navigate('create')
              setOpenAssignManagers(false)
              setOpenAssignEmployees(false)
            }}>
              <Add />
            </IconButton>
          </Grid2>
        </Container>

        <Container container flexDirection={'column'} overflow={'hidden'} spacing={2} padding={2}>
          <Grid2 container padding={2} sx={{ overflowX: 'hidden', overflowY: 'auto' }}>
            {
              !branches || !user ? Array.from({ length: 3 }).map((a, i) => <BranchCardSkeleton key={i} />) : branches.length == 0 ? <Typography>{translate("No Branches")}</Typography> :
                branches
                  // .concat(branches).concat(branches)
                  .map((b, i) => <BranchCard hideButtons={
                    user.role === 'admin' ? false :
                      user.role === 'employee' ? true :
                        user.role === 'manager' ?
                          b.branch_managers.includes(user.user_id) ? false : true
                          : false
                  } key={i} branch={b} index={location.pathname.split('/')[3] ? undefined : i} />)
            }
          </Grid2>
          <Grid2 size={'grow'} />
        </Container>

      </Grid2>

      <Grid2 container size={location.pathname.split('/')[3] ? 'grow' : -1} sx={{ transition: { xs: 'none', lg: 'all 0.5s ease' } }} flexDirection={'column'} gap={(openAssignManagers || openAssignEmployees) ? 2 : 0} >
        <Container>
          <Outlet context={{ setOpenAssignManagers, setOpenAssignEmployees }} />
        </Container>
        <Container size={openAssignManagers ? 'grow' : 0} sx={{ transition: 'all 0.5s ease' }}>
          {openAssignManagers && location.pathname.split('/')[3] && <AssignManagers setOpenAssignManagers={setOpenAssignManagers} />}
        </Container>
        <Container size={openAssignEmployees ? 'grow' : 0} sx={{ transition: 'all 0.5s ease' }}>
          {openAssignEmployees && location.pathname.split('/')[3] && <AssignEmployees setOpenAssignEmployees={setOpenAssignEmployees} />}
        </Container>
      </Grid2>

    </Grid2>
  )
})

export default SystemBranches